export function toDosCommandLineArgument(s: string): string {
    //
    // to be "compatible" with usage of CommandLineToArgvW the the \" rules which are:
    //
    //  * " - toggle quote mode (add whitespace to argument or terminate argument)
    //  * "" - toggle quote mode (add whitespace to argument or terminate argument) and add single quote to argument
    //
    //  So to add a " in the argument you need """ which means a combo of the above, namely: "" followed by a "
    //  e.g. " -> """
    //
    //  This is on complicated by the following backslash rules which override the above rules:
    //
    // {quote}
    // CommandLineToArgvW has a special interpretation of backslash characters when they are followed by a quotation mark character (").
    // This interpretation assumes that any preceding argument is a valid file system path, or else it may behave unpredictably.
    //
    //  This special interpretation controls the "in quotes" mode tracked by the parser. When this mode is off, whitespace terminates
    //  the current argument. When on, whitespace is added to the argument like all other characters.
    //
    //  * 2n backslashes followed by a quotation mark produce n backslashes followed by begin/end quote. This does not become part of
    //    the parsed argument, but toggles the "in quotes" mode.
    //  * (2n) + 1 backslashes followed by a quotation mark again produce n backslashes followed by a quotation mark literal ("). This
    //    does not toggle the "in quotes" mode.
    //  * n backslashes not followed by a quotation mark simply produce n backslashes.
    // {quote}
    //

    let sb: string[] = []

    // surround the argument with "" so that we can have spaces within the argument
    // but we need to escape " characters and [\...]\" sequences using the rules:
    //  * (2n) + 1 backslash rule [\...]\" => [\\...]\\\"
    //  * quote rule " => """
    //  * 2n backslash rule (i.e. only at the argument end) [\...]\" => [\\...]\\"
    sb.push('"')

    let backslashCount = 0;
    for (const ch of s) {
        if (ch === '\\') {
            sb.push(ch)
            ++backslashCount
        } else if (ch === '"') {
            if (backslashCount > 0) {
                // (2n) + 1 backslash rule
                sb.push('\\'.repeat(backslashCount + 1));
                sb.push(ch);
            }
            else {
                // quote rule
                sb.push('"""');
            }
        }
        else {
            backslashCount = 0;
            sb.push(ch);
        }
    }

    if (backslashCount > 0)
    {
        // 2n backslash rule
        sb.push('\\'.repeat(backslashCount));
    }

    sb.push('"')

    return sb.join('')
}